import { Directive } from '@angular/core';

@Directive({
  selector: 'xpo-ltl-popover-header, xpo-ltl-popover-title',
  host: { class: 'xpo-ltl-Popover-header' },
})
export class XpoLtlPopoverHeader {}
